import BuilderModel from "~/models/tracked/builderModel";
import Guid from "~/helpers/guid";
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import {IJumpTo} from '~/interfaces/modeling/jumpToInterfaces'

export default class ProcessFlowStepJumpTo extends BuilderModel implements IJumpTo {
  to_client_id: string;
  client_id: string = Guid.create();

  // ******************** RELATIONS AND REPOS ******************** //

  static repo: IRepo<ProcessFlowStepJumpTo> = new Repo<ProcessFlowStepJumpTo>('processFlowStepJumpTos', ProcessFlowStepJumpTo, {});
  repo: IRepo<this>;

  addToRepo(): void {
    ProcessFlowStepJumpTo.repo.add(this)
  }

  get titleOrDefault() {
    return "END";
  }

  get isCollectionRoot(): boolean {
    return false;
  }

  get nextSteps() {
    return [];
  }
}